module.exports = __webpack_public_path__ + "static/media/trendex-usa-min.1de9bf32.png";